<div id="container">
  <div [chart]="chart"></div>
  <mat-checkbox (change)="toggleSeries($event)" [checked]="showAllSeries">
    {{showAllSeries ? 'Összes elrejtése' : 'Összes mutatása'}}
  </mat-checkbox>
</div>
